import angular from "angular"
import React from "react"
import { react2angular } from "react2angular"
import AwesomeSlider from "react-awesome-slider"
import "react-awesome-slider/dist/styles.css"
import nanoid from "nanoid"

import "./fullScreenViewer.scss"

const handleKeyUp = (event, props) => {
  if (event.key === "Escape") {
    if (props) {
      props.closeGallery()
    }
  }
}

function FullScreenViewer(props) {
  React.useEffect(() => {
    document.addEventListener("keyup", (event) => handleKeyUp(event, props), false)
    return function cleanup() {
      document.removeEventListener("keyup", (event) => handleKeyUp(event, props))
    }
  }, [])
  return (
    <div className="fullscreen-viewer">
      <AwesomeSlider fillParent>
        {props.pitchImageUrls.map((slideUrl) => (
          <div data-src={slideUrl} key={nanoid()} />
        ))}
      </AwesomeSlider>
      <div className="fullscreen-viewer__close-button" onClick={props.closeGallery}>
        Close
      </div>
    </div>
  )
}

export default angular
  .module("makeamapAngularApp.fullscreenviewer", [])
  .component("fullscreenviewer", react2angular(FullScreenViewer, ["pitchImageUrls", "closeGallery"])).name
